export enum FormCommit {
    INITIALIZE_DATA = 'initializeData',
    USER_SHIPPING = 'userShipping',
    SUCCESS_MODAL_VISIBILITY = 'successModalVisibility',
    CLEAR_USER_GROUP_CHOICES = 'clearUserGroupChoice',
}
